



















import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalProjectCloseReport",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalProjectCloseReport extends Vue {
  get fetchData() {
    return api.externalProjectCloseReport.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalProjectCloseReportDetail",
      params: { id: dto.id!.toString() },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
